(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-pro"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-pro')) {
    customElements.define(
      'product-card-pro',
      class ProductCardPro extends HTMLElement {
        connectedCallback() {
          if (this.dataset.extractColor !== 'true') return;

          const img = this.querySelector('.product-card-pro__image');
          if (!(img instanceof HTMLImageElement)) return;

          const applyColor = () => this.extractColor(img);

          if (img.complete && img.naturalWidth > 0) {
            applyColor();
            return;
          }

          img.addEventListener('load', applyColor, { once: true });
        }

        extractColor(visibleImage) {
          const probe = new Image();
          probe.crossOrigin = 'anonymous';
          probe.decoding = 'async';
          probe.onload = () => {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d', { willReadFrequently: true });
              if (!ctx) return;

              const size = 48;
              canvas.width = size;
              canvas.height = size;
              ctx.drawImage(probe, 0, 0, size, size);
              const sample = ctx.getImageData(0, 0, size, size);
              const data = sample.data;
              const startY = Math.floor(size * 0.28);
              const third = Math.floor(size / 3);

              const averageRegion = (x0, x1) => {
                let r = 0;
                let g = 0;
                let b = 0;
                let n = 0;
                for (let y = startY; y < size; y++) {
                  for (let x = x0; x < x1; x++) {
                    const i = (y * size + x) * 4;
                    if (data[i + 3] < 140) continue;
                    const brightness = (data[i] * 299 + data[i + 1] * 587 + data[i + 2] * 114) / 1000;
                    if (brightness > 230 || brightness < 14) continue;
                    r += data[i];
                    g += data[i + 1];
                    b += data[i + 2];
                    n += 1;
                  }
                }
                if (!n) return null;
                const darken = 0.76;
                return this.adjustColor(
                  Math.round((r / n) * darken),
                  Math.round((g / n) * darken),
                  Math.round((b / n) * darken)
                );
              };

              const left = averageRegion(0, third);
              const center = averageRegion(third, third * 2);
              const right = averageRegion(third * 2, size);
              const fallback = center || left || right;
              if (!fallback) return;

              const leftColor = left || fallback;
              const centerColor = center || fallback;
              const rightColor = right || fallback;

              this.style.setProperty('--pcp-color-left', `rgb(${leftColor.join(', ')})`);
              this.style.setProperty('--pcp-color', `rgb(${centerColor.join(', ')})`);
              this.style.setProperty('--pcp-color-right', `rgb(${rightColor.join(', ')})`);
              this.applyContrast(centerColor[0], centerColor[1], centerColor[2]);
            } catch (error) {
              return;
            }
          };
          probe.src = visibleImage.currentSrc || visibleImage.src;
        }

        adjustColor(r, g, b) {
          const adjust = Number(this.dataset.colorAdjust || 0);
          if (!adjust) return [r, g, b];
          if (adjust < 0) {
            const amount = -adjust / 100;
            return [
              Math.round(r * (1 - amount)),
              Math.round(g * (1 - amount)),
              Math.round(b * (1 - amount))
            ];
          }
          const amount = adjust / 100;
          return [
            Math.round(r + (255 - r) * amount),
            Math.round(g + (255 - g) * amount),
            Math.round(b + (255 - b) * amount)
          ];
        }

        applyContrast(r, g, b) {
          if (this.dataset.lockText === 'true') return;
          const toLinear = (channel) => {
            const value = channel / 255;
            if (value <= 0.03928) return value / 12.92;
            return Math.pow((value + 0.055) / 1.055, 2.4);
          };
          const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
          const contrastWith = (other) => {
            const lighter = Math.max(luminance, other);
            const darker = Math.min(luminance, other);
            return (lighter + 0.05) / (darker + 0.05);
          };
          const useDarkText = contrastWith(0) > contrastWith(1);
          this.style.setProperty('--pcp-text', useDarkText ? '#111111' : '#ffffff');
          this.style.setProperty('--pcp-cta-text', useDarkText ? '#ffffff' : '#111111');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
